import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserInfos } from 'src/app/_models/user.infos';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<UserInfos>;
    public currentUser: Observable<UserInfos>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<UserInfos>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): UserInfos {
        return this.currentUserSubject.value;
    }

    public getUserInfos(): UserInfos{
        return this.currentUserSubject.value;
    }

    login(userInfos: UserInfos) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(userInfos));
        this.currentUserSubject.next(userInfos);
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}